import React, { useMemo } from "react";
import classnames from "classnames";
import type { QueryResponseType } from "@whatslly/types/QueryResponse";
import { StatusBar } from "./components/StatusBar";
import { OppsBar } from "./components/OppsBar";
import { useInjectedComponent } from "../useInjectedComponent";
import styles from "./status-bar-widget-app.module.scss";
import oppsStyles from "./components/OppsBar/opps-bar.module.scss";
import type { LeadStatusType } from "@whatslly/types/LeadStatus";
import type { UserType } from "@whatslly/types/User";
const StatusOnly: React.FC<{ leadStatus?: string; leadStatuses?: LeadStatusType[]; user?: UserType; parentItemId?: string }> = ({
  leadStatus,
  leadStatuses,
  user,
  parentItemId,
}) => (
  <div className={oppsStyles.opRows}>
    <div className={oppsStyles.opRow}>
      <div className={classnames(oppsStyles.opLink, oppsStyles.compact)}>
        <span className={classnames(oppsStyles.link, oppsStyles.disabled)}>Status</span>
      </div>
      <StatusBar
        className={styles.leadStatusBar}
        allowChangeItem={user?.allowChangeLeadStatus}
        initCurrentItemValue={leadStatus}
        items={leadStatuses}
        parentItemId={parentItemId}
        parentItemType={"Lead"}
      />
    </div>
  </div>
);

export const StatusBarWidgetApp: React.FC<{
  widgetOpen: boolean;
  queryResponse: QueryResponseType;
}> = ({ queryResponse, ...props }) => {
  const { isWidgetOpen } = useInjectedComponent(props);
  const person = queryResponse?.success ? queryResponse?.person : undefined;
  const user = queryResponse.user;
  const leadStatus = queryResponse.success ? queryResponse.leadStatus : undefined;
  const leadStatuses = queryResponse.success ? queryResponse.leadStatuses : undefined;
  const oppsOrder = queryResponse.success ? queryResponse.oppsOrder : undefined;
  const opps = queryResponse.success ? queryResponse.opps : undefined;

  const leadId = useMemo(() => {
    return person && !Array.isArray(person) ? person.Id : undefined;
  }, [person]);

  const showLeadStatusBar = useMemo(
    () => user?.showLeadStatusBar && person && !Array.isArray(person) && leadStatus && Array.isArray(leadStatuses) && leadStatuses.length > 0,
    [person, leadStatus, leadStatuses, user]
  );

  const showOppsStatusBar = useMemo(() => {
    return (
      user?.showOpps &&
      user?.showOppsStatusBar &&
      oppsOrder &&
      Array.isArray(oppsOrder) &&
      oppsOrder.length > 0 &&
      opps &&
      Array.isArray(opps) &&
      opps.length > 0
    );
  }, [user, opps, oppsOrder]);

  if (!isWidgetOpen) {
    return null;
  }

  return (
    <div id="whatslly-status-bar-container" className={styles.statusBarContainer}>
      {showLeadStatusBar && <StatusOnly parentItemId={leadId} leadStatus={leadStatus} leadStatuses={leadStatuses} />}
      {showOppsStatusBar && <OppsBar opps={opps} oppsOrder={oppsOrder} user={user} />}
    </div>
  );
};
